export default function SFWalletFilledIcon({}) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 12.3644V7.79445C2 6.60445 2.73 5.54441 3.84 5.12441L11.78 2.12441C13.02 1.65441 14.35 2.57444 14.35 3.90444V7.70442"
        fill="#A19BFD"
      />
      <path
        d="M6 6C3.23858 6 1 8.23858 1 11V18C1 20.7614 3.23858 23 6 23H17C19.7614 23 22 20.7614 22 18V11C22 8.23858 19.7614 6 17 6H6Z"
        fill="#A19BFD"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M15.0124 14.722L15.0124 14.722L15.0113 14.7099C14.938 13.9616 15.2286 13.2518 15.7575 12.7494C15.7636 12.7436 15.7697 12.7377 15.7757 12.7317C16.2332 12.2745 16.872 12 17.5956 12H21.2249C21.6997 12.0234 22 12.3828 22 12.7414V16.2586C22 16.6172 21.6997 16.9766 21.2249 17H17.8061C16.328 17 15.1178 15.9526 15.0124 14.722Z"
        fill="#A19BFD"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 12H12"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
